import script from "./UsersTableLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./UsersTableLoader.vue?vue&type=script&setup=true&lang=js"

import "./UsersTableLoader.vue?vue&type=style&index=0&id=c65796d2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c65796d2"]])

export default __exports__